export const API_GET_TRANSLATIONS_FILE = "API_GET_TRANSLATIONS_FILE"
export const API_POST_TRANSLATIONS_FILE = "API_POST_TRANSLATIONS_FILE"